<template>
  <div class="display_inline_block">
    <div class="is-flex is-align-items-center">
      <p><b>Location: </b></p>
      <div class="horizontal_space"></div>
      <p v-if="showCreateButton" @click="createLocation" class="btn blue_text">CREATE</p>
      <p v-else @click="editLocation" class="btn white_space_pre_line break_word blue_text">{{payload.location.description}}</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'location-editor',
  props: ['payload', 'onSubmit'],
  computed: {
    showCreateButton () {
      return !this.hasDescription
    },
    hasDescription () {
      return this.payload.location != undefined && this.payload.location.description != undefined && this.payload.location.description.length > 0
    }
  },
  methods: {
    createLocation () {
      this.create({
        designator: 'location-editor-modal',
        component_name: 'LocationsForm',
        is_create: true,
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id,
        company_id: this.payload.company_id,
        modal_title: 'Create new Location',
        position_status: this.payload.status,
        props: {
          onSubmit: location => {
            if (this.onSubmit) {
              this.onSubmit(location)
            }
          }
        }
      })
    },
    editLocation () {
      this.create({
        designator: 'location-editor-modal',
        component_name: 'LocationsForm',
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id,
        company_id: this.payload.company_id,
        modal_title: this.payload.location.description,
        position_status: this.payload.status,
        props: {
          onSubmit: location => {
            if (this.onSubmit) {
              this.onSubmit(location)
            }
          }
        }
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
